import getImageSource from './getImageSource';

function extractYouTubeId(input) {
    if (!input) return null;
    const s = String(input).trim();

    const justId = s.match(/^([A-Za-z0-9_-]{11})(?:[?&].*)?$/);

    if (justId) return justId[1];

    try {
        const u = new URL(
            s,
            s.startsWith('http') || s.startsWith('//') ? undefined : 'https://www.youtube.com/watch?v='
        );

        const host = u.hostname.replace(/^www\./, '');

        if (host === 'youtu.be') {
            const seg = u.pathname.split('/').filter(Boolean)[0];

            if (seg) return seg;
        }
        if (host.endsWith('youtube.com')) {
            const v = u.searchParams.get('v');

            if (v) return v;

            const mEmbed = u.pathname.match(/\/embed\/([A-Za-z0-9_-]{11})/);

            if (mEmbed) return mEmbed[1];

            const mShorts = u.pathname.match(/\/shorts\/([A-Za-z0-9_-]{11})/);

            if (mShorts) return mShorts[1];
        }
    } catch {
        /* fall through */
    }

    const any = s.match(
        /(?:v=|vi=|\/v\/|\/vi\/|youtu\.be\/|\/embed\/|\/shorts\/|^)([A-Za-z0-9_-]{11})(?:[^A-Za-z0-9_-]|$)/
    );

    return any ? any[1] : null;
}

export default async function youtubeThumbnailResolver(selector, videoUrl, retries = 10) {
    const els = document.querySelectorAll(selector);

    if (els.length) {
        return Promise.all(Array.from(els).map((el) => resolveThumbnail(el, videoUrl)));
    }
    if (retries > 0) {
        return new Promise((resolve) =>
            setTimeout(() => resolve(youtubeThumbnailResolver(selector, videoUrl, retries - 1)), 100)
        );
    }
}

async function resolveThumbnail(el, videoUrl) {
    const bgMatch = el.style.backgroundImage.match(/url\(["']?(.+?)["']?\)/);
    let orig = bgMatch?.[1];

    if (!orig && videoUrl) {
        const id = extractYouTubeId(videoUrl);

        orig = `https://i.ytimg.com/vi/${id}/hqdefault.jpg`;
    }

    if (!orig) {
        return;
    }

    const tryUrls = [
        orig.replace(/(hq|sd)?default/gi, 'maxresdefault'),
        orig.replace(/(hq|sd)?default/gi, 'hqdefault'),
        orig.replace(/(hq|sd)?default/gi, 'sddefault'),
        orig.replace(/(hq|sd)?default/gi, 'default'),
    ];

    const src = await getImageSource(tryUrls, orig, { minWidth: 480 });

    el.style.backgroundImage = `url("${src}")`;
}
